/**
 * Describes the configuration of Google IMA.
 *
 * @internal
 */
export interface GoogleImaConfiguration {
  /**
   * Whether the native (mobile) IMA implementation will be used.
   *
   * @internal
   */
  useNativeIma: boolean;
}
